import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* ABOUT */}
        <div className="footer-section">
          <h3>અમારા વિશે</h3>
          <p>
            અમારી સોસાયટી મહિલાઓને આર્થિક રીતે મજબૂત બનાવવા માટે
            લોન અને વીમા સુવિધાઓ પૂરી પાડે છે અને સહકારી ભાવનાથી કાર્ય કરે છે.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h3>ઝડપી લિંક્સ</h3>
          <ul>
            <li><a href="/home">હોમ</a></li>
            <li><a href="/about">અમારા વિશે</a></li>
            <li><a href="/gallery">પ્રવૃત્તિઓ</a></li>
            <li><a href="/join">સંપર્ક</a></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-section">
          <h3>સંપર્ક કરો</h3>

          <p>
           "માતૃછાયા બંગ્લોઝ", લાયબ્રેરી ની સામે સુરત ડિસ્ટ્રિક્ટ બેંક કતારગામ શાખા ની બાજુ માં ,સ્વામિનારાયણ મંદિર ની સામે ,કતારગામ મેઈન રોડ ,સુરત-4.
          </p>
  <p> ૭૨૦૩૦ ૩૦૨૩૬ / ૯૭૨૬૦ ૫૭૩૭૯</p>
   <p>shreedhanlaxmimahila123@gmail.com</p>
          
        </div>

        {/* SOCIAL MEDIA */}
        <div className="footer-section">
        
          <h3>કામકાજ નો સમય </h3>
          <p>સોમ થી શનિ :- 10:00 થી 5:00</p>
         
          <p>બીજા તથા ચોથા શનિવારે રાજા રહેશે.</p>
          <h3>અમને ફોલો કરો</h3>

          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
          </div>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© 2025  શ્રી ધનલક્ષ્મી મહિલા કો-ઓપ. ક્રેડિટ સોસાયટી | All Rights Reserved</p>
      </div>

    </footer>
  );
}